import { useEffect, useState } from 'react';

import { Image } from 'antd';

import { advertisingRightSide } from '@/apis/op';
import { buriedPoint } from '@/utils/buriedPoint';
import Utils from '@/utils/Utils';

export default function FloatAdvert() {
  const [show, setShow] = useState(false);
  const [floatAd, setFloatAd] = useState(null);

  useEffect(() => {
    init();
  }, []);

  function init() {
    const sideAdObj = Utils.getLocal('lcsc-side-ad');
    const current = new Date().getTime();
    if (!sideAdObj || current - sideAdObj?.lastTime > 1000 * 60 * 60 * 24) {
      advertisingRightSide()
        .then((res) => {
          if (res?.result) {
            setFloatAd(res?.result);
            setShow(true);
          }
        })
        .catch((error) => {
          console.error('右侧浮动广告异常', error);
        });
    } else {
      setShow(false);
    }
  }

  function handleClick(event) {
    event.stopPropagation();
    setShow(false);
    const sideAdObj = {
      lastTime: new Date().getTime(),
    };
    Utils.setLocal('lcsc-side-ad', JSON.stringify(sideAdObj));
    buriedPoint({
      cp: 'side_float_adv',
      op: 'search_page',
      data: { ck: 'close', hf: floatAd?.targetLink },
    });
  }

  function gotoAd() {
    buriedPoint({
      cp: 'side_float_adv',
      op: 'search_page',
      data: { ck: 'open', hf: floatAd?.targetLink },
    });
  }

  return (
    show && (
      <div className="custom-group fixed right-[80px] top-[26%] z-[999]">
        <i className="absolute right-0 top-[0] z-[2] block size-[26px] cursor-pointer" onClick={handleClick}></i>
        <a
          data-spm="lad"
          className="inline-block"
          href={floatAd?.targetLink}
          aria-label={floatAd?.title}
          target="_blank"
          onClick={gotoAd}
        >
          <Image src={floatAd?.advertisingUrl} width={188} height={157} alt="浮动侧边栏广告" preview={false}></Image>
        </a>
      </div>
    )
  );
}
